import type { CardProps } from "@karrtopelka/cards/types";
import { rocketProvocation } from "@karrtopelka/cards/provocations";

/** Cashout card off the shared flight. */
export function buildRocketCard(
  mult: number,
  value: number,
  handle: string,
  submit: { total: number; percentile: number } | null,
): CardProps {
  const props: CardProps = {
    game: "rocket",
    display: `${mult.toFixed(2)}x`,
    handle,
    provocation: rocketProvocation(value),
    date: new Date().toISOString().slice(0, 10),
  };
  if (submit && submit.total >= 10) {
    props.rankLine = `top ${submit.percentile}% today`;
  }
  return props;
}
